import { all, takeLatest } from 'redux-saga/effects'
import store from '../../store'
import { actions } from './CustomLabels.slice'
import { paginate } from './CustomLabels.thunk'

function paginateCustomLabels () {
  store.dispatch(paginate() as any)
}

export default function * effects () {
  yield all([
    takeLatest(actions.replaceLimit, paginateCustomLabels),
    takeLatest(actions.replacePage, paginateCustomLabels),
    takeLatest(actions.replaceSearch, paginateCustomLabels),
    takeLatest(actions.replaceSorting, paginateCustomLabels)
  ])
}
